'use client'

import { useMemo } from 'react'
import useSWR from 'swr'

import { getProductsStockByIds } from '@maestro/commerce-blocks/client/api/products'

export const useProductStockDataFetcher = (
  productIds: string[],
  baseProductId?: string
) => {
  const swrKey = useMemo(() => {
    if (!productIds.length) {
      return null
    }
    return ['products-stock', [...productIds].sort().join(',')]
  }, [productIds])

  const { data, isLoading } = useSWR(
    swrKey,
    () => getProductsStockByIds(productIds, baseProductId),
    {
      revalidateOnFocus: false,
    }
  )

  return {
    productsStockMap: data,
    isLoading,
  }
}
